export default "__VITE_ASSET__DEVpL215__"